/* 🤖 this file was generated by svg-to-ts */
export const iconTrustwallet: {
  name: 'trustwallet';
  data: string;
} = {
  name: 'trustwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m0 5.21 10.3 3.34v7.44c0 3.34-2.94 9.24-10.3 12.32-7.36-3.08-10.3-8.99-10.3-12.32V8.55z"/></svg>`,
};
